"use client";
import React from "react";
import "./Specialization_Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
// import { Context } from "../../../utils/context";
import Common_Form from "../../../components/common_components/common_form/Common_Form";

const Specialization_Banner = () => {
  return (
    <section className="specialization-banner">
      <div className="container-fluid p-0">
        <div className="banner-image course_banner_div">
          <>
            <Swiper
              spaceBetween={30}
              pagination={{ clickable: true }}
              // className="mySwiper"
            >
              <SwiperSlide>
                <img
                  rel="preload"
                  loading="lazy"
                  className="ban-img"
                  width="1920"
                  height="700"
                  src="/assets/images/Banner/1768544400412-DPU â__ MCA â__ 2.webp"
                />
              </SwiperSlide>
            </Swiper>

            <div className="form_holder">
              <Common_Form />
            </div>
          </>
        </div>
      </div>
    </section>
  );
};

export default Specialization_Banner;
